import apiClient from '../apiClient';
import { PUT_SYSTEM_MARGIN_URL } from '../apiUrl';

const putSystemMarginApi = (id, data) => {
  return apiClient.put(PUT_SYSTEM_MARGIN_URL(id), data);
};

export default putSystemMarginApi;
